<template>
    <div class="vx-row">
        <div class="vx-col w-full mt-2 p-0">
            <div class="vx-card mt-2 p-6 height-card">
                <div class="component">
                    <span class="text-title-mentioned">
                    {{ $t("title.mentioned") }}
                    <div v-if="!showMentionedChart" class="lds-facebook">
                        <div></div>
                        <div></div>
                        <div></div>
                    </div>
                    </span>
                </div>
                <div class="component">
                    <span class="text-sub">
                        {{ $t('shareOfVoice.correlationOfMentions') }}
                    </span>
                </div>
                <div id="chart">
                    <vue-apex-charts
                        v-if="showMentionedChart"
                        type="bar"
                        height="450"
                        :options="mentionedChart.chartOptions"
                        :series="mentionedChart.series">
                    </vue-apex-charts>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import moment from 'moment'
export default {
    components:{
        VueApexCharts
    },
        props: {
        dateRange: {
            type: Object
        },
        refreshData: {default: 0},
        topics: {default:null}
    },
    watch: {
        refreshData: function (newVal, oldVal) {
            this.initScreen();
        }
    },
    data(){
        return {
            showMentionedChart: false,
            mentionedChart: {
                series: [],
                chartOptions: {
                chart: {
                    type: "bar",
                    height: 350,
                    stacked: true,
                    stackType: '100%'
                },
                colors: this.colorByTopic(),
                responsive: [
                    {
                    breakpoint: 480,
                    options: {
                        legend: {
                        position: "bottom",
                        offsetX: -10,
                        offsetY: 0
                        }
                    }
                    }
                ],
                markers: {
                    size: 0,
                    hover: {
                    size: 5
                    }
                },
                xaxis: {
                    labels: {
                    showDuplicates: false,
                    formatter: function(val) {
                        if (!val) return val;
                        let dateSplit = val.split("-"),
                        type = dateSplit[1],
                        dateTemp = moment(dateSplit[0], "YYYYMMDD");

                        if (type === "W") return `Tuần ${dateTemp.isoWeek()}`;

                        if (type === "M")
                        return ` ${dateTemp.format("MM")}/${dateTemp.year()}`;

                        return val.slice(6, 8) + "/" + val.slice(4, 6);
                    },
                    style: {
                        cssClass: "text-grey fill-current"
                    }
                    },
                    axisTicks: {
                    show: false
                    },
                    categories: [],
                    tooltip: {
                    enabled: false
                    }
                },
                yaxis: {
                    tickAmount: 5,
                    labels: {
                    style: {
                        cssClass: "text-grey fill-current"
                    },
                    formatter: function(val) {
                        if (Number(val) === val && val % 1 !== 0) {
                        return kFormatter(val).toFixed(1);
                        } else {
                        return kFormatter(val);
                        }
                    }
                    },
                    grid: {
                    show: false
                    }
                },
                fill: {
                    opacity: 1
                },
                legend: {
                    show: false,
                    position: "top",
                    // offsetX: 0,
                    // offsetY: 50
                    markers: {
                    fillColors: ["#2F80ED", "#27AE60", "#9B51E0", "#F2994A"]
                    }
                }
                }
            }
        }
    },
    methods: {
        getDataMentionedByDay: function(){
            this.showMentionedChart = false;
            let that = this;
            const payload = {
                from: this.dateRange.startDate,
                to: this.dateRange.endDate,
                topicId: null,
                topics: this.topics
            }
            this.$processor
                .post("/user-data/get-source-data-topic-by-day", payload)
                .then(topics => {
                that.mentionedChart.series = [];
                topics.data.forEach((topic) => {
                    topic.sourceDataTopicByDay = this.optimizedChart(topic.sourceDataTopicByDay)
                    that.mentionedChart.chartOptions.xaxis.categories = [];
                    that.mentionedChart.chartOptions.xaxis.categories.push(...topic.sourceDataTopicByDay.map(x => {
                    return x.stringDate
                    }));
                    that.mentionedChart.series.push({
                    name: topic.topicName,
                    data: topic.sourceDataTopicByDay.map(x => {
                        return x.totalData
                    })
                    });
                });
                that.showMentionedChart = true;
                });
        },
        optimizedChart: function (data){
            data = data.sort(function(a,b){
                return parseInt(a.stringDate) - parseInt(b.stringDate)
            })
            data.map(item => {
                let date = moment(item.stringDate, 'YYYYMMDD');
                item.month = date.format('Y') + date.format('M');
                item.week = date.isoWeek();
                item.day = date.format('D');
                return item;
            })

                let result = [];
                data.reduce(function(res, value) {
                if(data.length <= 21) {
                    if (!res[value.day]) {
                    res[value.day] = {day: value.day, stringDate: value.stringDate, totalData: 0};
                    result.push(res[value.day])
                    }
                    res[value.day].totalData += value.totalData;
                    res[value.day].stringDate += "-D";
                    return res;
                }
                if( 14 < data.length && data.length < 62){
                    if (!res[value.week]) {
                    res[value.week] = {week: value.week, stringDate: value.stringDate, totalData: 0};
                    result.push(res[value.week])
                    }
                    res[value.week].totalData += value.totalData;
                    res[value.week].stringDate += "-W";
                    return res;
                }
                else if(data.length > 62){
                    if (!res[value.month]) {
                    res[value.month] = {month: value.month, stringDate: value.stringDate, totalData: 0};
                    result.push(res[value.month])
                    }
                    res[value.month].totalData += value.totalData;
                    res[value.month].stringDate += "-M";
                    return res;
                }
                }, {});
                data = result;
                return data;

            },
        colorByTopic: function(){
            let colors = ['#33b2df', '#546E7A', '#d4526e', '#13d8aa', '#A5978B', '#2b908f', '#f9a3a4', '#90ee7e','#f48024', '#69d2e7'];  
            return colors;
        },
        initScreen(){
            this.getDataMentionedByDay();
        }
    },
    async created(){
        this.initScreen();
    }
}
function kFormatter(num) {
  if (num >= 1000000000) {
    return (num / 1000000000).toFixed(1).replace(/\.0$/, "") + "G";
  }
  if (num >= 1000000) {
    return (num / 1000000).toFixed(1).replace(/\.0$/, "") + "M";
  }
  if (num >= 1000) {
    return (num / 1000).toFixed(1).replace(/\.0$/, "") + "K";
  }
  return num;
}
</script>

<style scoped>
.height-card {
  height: 550px;
}
.text-title-mentioned {
    font-size: 18px;
    font-weight: bold;
    color: #5E5873;
}
.text-sub {
    font-size: 14px;
    color: #B9B9C3;
}
.lds-facebook {
  display: inline-block;
  position: relative;
  width: 20px;
  height: 20px;
  top: -3px;
  float: revert;
  padding-left: 25px;
}

.lds-facebook div {
  display: inline-block;
  position: absolute;
  left: 4px;
  width: 3px;
  background: #626262;
  animation: lds-facebook 1.2s cubic-bezier(0, 0.5, 0.5, 1) infinite;
}

.lds-facebook div:nth-child(1) {
  left: 4px;
  animation-delay: -0.24s;
}

.lds-facebook div:nth-child(2) {
  left: 10px;
  animation-delay: -0.12s;
}

.lds-facebook div:nth-child(3) {
  left: 16px;
  animation-delay: 0s;
}
@keyframes lds-facebook {
  0% {
    top: 8px;
    height: 16px;
  }

  50%,
  100% {
    top: 16px;
    height: 4px;
  }
}
</style>